<template>
    <div class="container-box pt-4">
        <div class="text-container">
            {{ $t('referrerForm.instructions')[0] }} <strong>{{ $t('referrerForm.instructions')[1] }}</strong>{{ $t('referrerForm.instructions')[2] }}
            <strong>{{ $t('referrerForm.instructions')[3] }}</strong>{{ $t('referrerForm.instructions')[4] }}
            <strong>{{ $t('referrerForm.instructions')[5] }}</strong> {{ $t('referrerForm.instructions')[6] }}
            <strong class="d-block">{{ $t('referrerForm.instructions')[7] }}</strong>
        </div>
        <div v-show="submissionError" class="error">{{ submissionError }}</div>
        <div class="form-container">
            <b-form-input
                ref="vatInput"
                v-model="form.vat"
                type="text"
                class="input-control"
                required
                size="lg"
                :placeholder="$t('referrerForm.vat')"
                :disabled="disabledVat"
                maxlength="9"
            />
            <span v-show="invalidVat || (form.vat.length > 2 && !validateVat())" class="ml-3">{{ $t('referrerForm.vatError') }}</span>
            <span v-if="vatNotFound" class="ml-3 d-inline-block">{{ $t('referrerForm.vatNotFound') }}</span>
            <b-form-input
                v-model="form.mobileNumber"
                type="text"
                class="input-control mt-2"
                required
                size="lg"
                :placeholder="$t('referrerForm.mobilePhone')"
                maxlength="10"
                :disabled="(vatNotFound || invalidVat || !validateVat()) || form.vat.length <= 2"
            />
            <span v-show="form.mobileNumber.length > 2 && !validatePhone()" class="ml-3">{{ $t('referrerForm.phoneError') }}</span>
            <router-link v-slot="{ href }" to="/ΔΗΛΩΣΗ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ.pdf" target="_blank">
                <a :href="href">
                    <pre class="privacy-policy mt-4">{{ $t('privacyPolicy') }}</pre>
                </a>
            </router-link>
            <div class="text-center">
                <button type="submit" class="submit" :disabled="success || ((!validateVat()) || form.vat.length <= 2) || (form.mobileNumber.length >= 2 && !validatePhone())" @click="submit">{{ $t('referrerForm.submit') }}</button>
            </div>
            <div v-show="success" class="sucess">{{ $t('referrerForm.success') }}</div>
            <router-link v-slot="{ href }" to="/Όροι & Προϋποθέσεις - Σελίδα Συστήνοντα.pdf" target="_blank">
                <a :href="href">
                    <div class="terms">
                        {{ $t('terms') }}
                    </div>
                </a>
            </router-link>
        </div>
    </div>
</template>

<script>
    import customerService from '@/services/customer-service'
    import referrerService from '@/services/referrer-service'
    export default {
        data() {
            return {
                form: {
                    mobileNumber: '',
                    referral: '',
                    vat: ''
                },
                invalidPhoneNumber: false,
                invalidVat: false,
                success: false,
                submissionError: '',
                disabledVat: false,
                vatNotFound: false
            }
        },
        watch: {
            'form.vat'() {
                this.vatNotFound = false
                if (this.validateVat()) {
                    customerService.exists(this.form.vat).then(resp => {
                        if (!resp.content) {
                            // this.submissionError = 'Το ΑΦΜ που καταχώρησες δεν ανταποκρίνεται σε πελάτη ELPEDISON, παρακαλώ πολύ καταχώρησε ξανά το ΑΦΜ σου'
                            this.vatNotFound = true
                            // this.form.vat = ''
                            // this.form.mobileNumber = ''
                            // this.disabledVat = true
                            // this.$refs.vatInput.blur()
                            // setTimeout(() => {
                            //     this.disabledVat = false
                            // }, 3000)
                            // this.$emit('customerNotFound')
                        } else {
                            this.submissionError = ''
                            this.invalidVat = false
                            this.vatNotFound = false
                        }
                    })
                }
            }
        },
        created() {
            if (this.$route.query.ref) {
                this.form.referral = this.$route.query.ref
            }
        },
        methods: {
            async submit() {
                this.resetFormErrors()
                if (!this.validateForm()) {
                    return
                }
                referrerService.createReferrer(this.form).then(resp => {
                    this.form.vat = ''
                    this.form.mobileNumber = ''
                    this.success = true
                }).catch(err => {
                    this.submissionError = err.response.data.message
                    setTimeout(() => { this.submissionError = null }, 12000)
                })
            },
            validateForm() {
                if (!this.validateVat()) {
                    this.invalidVat = true
                    return false
                }
                if (this.form.mobileNumber.length !== 10 || !this.validatePhone()) {
                    this.invalidPhoneNumber = true
                    return false
                }
                return true
            },
            validatePhone() {
                const reg = /^(69)\d{8}$/
                if (this.form.mobileNumber.length > 2 && !this.form.mobileNumber.match(reg)) {
                    return false
                }
                return true
            },
            validateVat() {
                const reg = /\d{9}$/
                if (!this.form.vat.match(reg)) {
                    return false
                }
                return true
            },
            resetFormErrors() {
                this.invalidPhoneNumber = false
                this.invalidVat = false
            }
        }
    }
</script>

<style scoped>
.container-box {
    width: 100%;
    background: rgba(255, 255, 255, .74);
    backdrop-filter: blur(13px);
    border-radius: 27px;
    box-shadow: 0px 3px 6px #00000029;
    padding-bottom: 20px;
}
.text-container,
.form-container {
    width: 90%;
    margin: 0 auto;
}
.text-container {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
}

.input-control {
    border-radius: 10px;
    font-size: 1.3rem;
    height: 35px;
}
.input-control::placeholder {
    color: rgb(139, 139, 139, .6)!important;
    font-family: 'RobotoRegular';
}
.input-control:disabled {
    background: rgb(143, 143, 143)!important;
    opacity: .6;
}
.input-control:disabled::placeholder {
    color: rgb(207, 207, 207)!important;
}
.submit {
    background: #99D24E;
    color: #fff;
    font-size: 30px;
    border-radius: 12px;
    border: none;
    font-weight: bold;
    padding: 5px 25px;
    margin-top: 1.5rem;
    transition: all 0.15s ease-in-out
}
.submit:hover {
    background-color: #7faf40;
}
.submit:active {
    transform: scale(0.9)
}
.submit:disabled {
    background: grey;
    opacity: .3;
}
.submit:focus-visible {
    outline: none;
}
.privacy-policy {
    margin-top: 1rem;
    font-size: 0.8rem;
    text-decoration: underline;
    text-align: center;
    text-decoration-skip-ink: none;
    font-family: 'RobotoRegular';
    cursor: pointer;
}
.terms {
    margin-top: 1rem;
    text-decoration: underline;
    font-size: .8rem;
    cursor: pointer;
}
span {
    color: #a70000;
    font-size: .7rem;
}
a, a:hover {
    text-decoration: none;
    color: inherit;
}
.sucess {
    text-align: center;
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
}
.error {
    color: #a70000;
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
}
@media screen and (min-width: 768px) {
    .text-container{
        font-size: 1.5rem;
        margin-bottom: 2.5rem;
    }
    .privacy-policy {
        margin-top: 1.5rem;
        font-size: 1rem;
    }
    .terms {
        font-size: 1.1rem;
    }
    span {
        font-size: .9rem;
    }
    .input-control {
        height: 65px;
        border-radius: 19px;
    }
}
@media screen and (min-width: 1280px) {
    .container-box {
        width: 40%;
    }
    .text-container{
        font-size: 1.5rem;
        margin-bottom: 3.5rem;
    }
    .input-control {
        font-size: 1.8rem;
    }
    .privacy-policy {
        font-size: 1.1rem;
    }
    .submit {
        margin-top: 2.5rem;
    }
    span {
        font-size: 1rem;
    }
}
@media screen and (min-width: 1625px) {
    .text-container{
        font-size: 1.7rem;
        margin-bottom: 3.5rem;
    }
    .input-control {
        font-size: 2rem;
    }
}
@media screen and (max-width: 500px) {
    .submit {
        font-size: 1rem;
        margin-top: 0px;
    }
    .text-container {
        font-size: .9rem;
    }
    .success {
        font-size: 1rem;
    }
}
</style>
